var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#weight_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M53.977 29.681c.701.773.486 1.96-.368 2.56l-4.601 3.227c-.854.6-2.021.357-2.865-.256a5.712 5.712 0 0 0-6.561-.11c-.864.586-2.038.789-2.872.162l-4.492-3.38c-.833-.626-1.009-1.82-.282-2.57a15.11 15.11 0 0 1 22.041.367m-1.563 1.091a13.22 13.22 0 0 0-18.952-.315l4.38 3.294c.014.005.05.012.123.006.149-.014.356-.082.558-.218a7.6 7.6 0 0 1 4.532-1.302 1 1 0 0 1 .14-.214l2.595-2.983a.944.944 0 0 1 1.425 1.24l-2.035 2.34a7.6 7.6 0 0 1 2.073 1.064c.197.143.402.218.55.236a.3.3 0 0 0 .124 0zm-4.48 3.144q0 0-.007.003zm-10.1-.168q.001 0 .008.003-.008-.002-.007-.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M54.322 54a3.78 3.78 0 0 0 3.772-3.568l1.469-26.445A3.78 3.78 0 0 0 55.79 20H29.778a3.78 3.78 0 0 0-3.772 3.987l1.47 26.445A3.78 3.78 0 0 0 31.246 54zm-23.075-1.889h23.075c1.002 0 1.83-.783 1.886-1.784l1.469-26.444a1.89 1.89 0 0 0-1.886-1.994H29.778c-1.084 0-1.946.91-1.886 1.994l1.469 26.444a1.89 1.89 0 0 0 1.886 1.784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "weight_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35625",
    result: "shape"
  })))));
};
export default SvgWeight;